// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Overall } from '../Tooltips'

const FormatOverall = ({ columnKey, rowData }) => {
  const {
    overallHeight,
    uniqueId,
  } = rowData

  const tooltipContent = () => (
    <Overall tooltipData={rowData} />
  )

  const tooltipId = `lookup-tooltip-${uniqueId}-${columnKey}-${rowData[uniqueId]}`

  return (
    <div className={'display-flex justify-content-start align-items-center'}>
      <p>{overallHeight}</p>
      <p
        className={'show-decoration margin-left-half text-blue-dark'}
        data-class={'tooltip-wrapper'}
        data-for={tooltipId}
        data-tip={true}
        id={`${tooltipId}-trigger`}>
        <i className={'fa fa-plus-circle'} />
      </p>
      <ReactTooltip
        delayHide={200}
        effect={'solid'}
        id={tooltipId}
        getContent={tooltipContent}
        place={'bottom'}
        type={'light'} />
    </div>
  )
}

FormatOverall.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatOverall
